/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type AgelessAssessmentStep =
  (typeof AgelessAssessmentStep)[keyof typeof AgelessAssessmentStep];

export const AgelessAssessmentStep = {
  PreScan: "PreScan",
  ImageCapture: "ImageCapture",
  Processing: "Processing",
  VerifyInfo: "VerifyInfo",
  Score: "Score",
  TreatmentModeSelection: "TreatmentModeSelection",
  AiTreatments: "AiTreatments",
  ManualTreatments: "ManualTreatments",
  Transformation: "Transformation",
  NextSteps: "NextSteps",
  FutureSelf: "FutureSelf",
  WellnessPreScan: "WellnessPreScan",
  WellnessVerifyInfo: "WellnessVerifyInfo",
  WellnessImageCapture: "WellnessImageCapture",
  WellnessTransformation: "WellnessTransformation",
  WellnessResults: "WellnessResults",
  Results: "Results",
} as const;
